import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { assignmentUpdate } from '../../redux/actions/assignments';

const EditAssignmentModal = ({ payload, supplierId, showEditAssignmentModal, setShowEditAssignmentModal, assignment, assignmentName, updateAssignment, settings, accountUnits, modalY }) => {
  const [supplierPrice, setSupplierPrice] = useState(null);
  const [minOrder, setMinOrder] = useState(null);
  const [supplierSku, setSupplierSku] = useState(null);
  const [orderMultiple, setOrderMultiple] = useState(null);
  const [packQuantity, setPackQuantity] = useState(null);

  const focus = (event) => {
    event.target.parentElement.classList.add("field--focus");
  }

  const blur = (event) => {
    event.target.parentElement.classList.remove("field--focus");
  }

  const clearAndClose = () => {
    setSupplierPrice(null);
    setMinOrder(null);
    setSupplierSku(null);
    setOrderMultiple(null);
    setPackQuantity(null);
    setShowEditAssignmentModal(false);
  }

  const format = (value) => {
    return (accountUnits.currencyPrefix + (parseFloat(value) || 0).toFixed(parseInt(accountUnits.currencyPrecision)) + accountUnits.currencySuffix).replace('.', accountUnits.currencyDecimalSeparator);
  }

  const update = () => {
    let assignmentValues = { supplierPrice: supplierPrice, minOrder: minOrder, supplierSku: supplierSku };
    
    if(settings?.settings?.order_multiples) {
      assignmentValues.orderMultiple = orderMultiple;
    }

    if(settings?.settings?.pack_quantities) {
      assignmentValues.packQuantity = packQuantity;
    }

    updateAssignment(payload, supplierId, assignment, assignmentValues);
    clearAndClose();
  }

  const validateQuantity = (event, setField) => {
    let value = event.target.value;
    setField(value.replace(/[^\d.-]+/g, '') || 0.0);

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
  }

  const validateInteger = (event, setField) => {
    let value = parseInt(event.target.value).toString();
    setField(value || 0);

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
  }

  const validateValue = (event, setField) => {
    let value = event.target.value;
    setField(value);

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
  }

  return(
    <div className="main-overlay">
      <div style={{ top: `${modalY}px`, transform: 'translate(0%, -50%)', position: 'fixed' }} className="main-popup main-popup_center main-popup--thin-padding main-popup_animation">
        <div className="main-popup__container">
          <div className="main-popup__close" onClick={() => clearAndClose()}>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7929 1.7929c.3905-.3905 1.0237-.3905 1.4142 0L9 7.5858l5.7929-5.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L10.4142 9l5.7929 5.7929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L9 10.4142l-5.7929 5.7929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L7.5858 9l-5.793-5.7929c-.3904-.3905-.3904-1.0237 0-1.4142z">
              </path>
            </svg>
          </div>
          <div className="main-popup__subcontainer">
            <h3 className="main-popup__title">
              <span className="gwt-InlineHTML">Update Assignment</span>
            </h3>
            <div className="main-popup__text" aria-hidden="true" style={{display: 'none'}}></div>
            <div className="main-popup__content">
              <h4>{assignmentName}</h4>

              Current Supplier SKU: {assignment?.supplier_sku}<br/>
              Current Supplier Price: {assignment?.supplier_price ? format(assignment.supplier_price) : null}<br/>
              Current MOQ: {assignment?.minimum_order}
              { settings?.settings?.order_multiples &&
                <><br/>Current Order Multiple: {assignment?.order_multiple}</>
              }
              { settings?.settings?.pack_quantities &&
                <><br/>Current Pack Quantity: {assignment?.pack_quantity}</>
              }

              <hr/>

              <div className="fieldset">

                <div className="field field--medium field--filled">
                  <span className="fieldset__svg-icon"></span>
                  <label className="field__label">Update Supplier SKU</label>
                  <input onFocus={focus} onBlur={blur} tabindex="4" maxlength="64" className="field__input" id="update_supplier_sku" type="text" value={supplierSku} onChange={(e) => validateValue(e, setSupplierSku)} />
                  <div className="field__placeholder">Update Supplier SKU</div>
                </div>

                <div className="field field--medium field--filled">
                  <span className="fieldset__svg-icon"></span>
                  <label className="field__label">Update Supplier Price</label>
                  <input onFocus={focus} onBlur={blur} tabindex="4" maxlength="64" className="field__input" id="update_supplier_price" min="0" type="number" value={supplierPrice} onChange={(e) => validateQuantity(e, setSupplierPrice)} />
                  <div className="field__placeholder">Update Supplier Price</div>
                </div>

                <div className="field field--medium field--filled">
                  <span className="fieldset__svg-icon"></span>
                  <label className="field__label">Update Order Minium Quantity</label>
                  <input onFocus={focus} onBlur={blur} tabindex="4" maxlength="64" className="field__input" id="update_minimum_quantity" step="1" min="0" type="number" value={minOrder} onChange={(e) => validateInteger(e, setMinOrder)} />
                  <div className="field__placeholder">Update Order Minium Quantity</div>
                </div>

                { settings?.settings?.order_multiples && 
                  <div className="field field--medium field--filled">
                    <span className="fieldset__svg-icon"></span>
                    <label className="field__label">Order Multiple</label>
                    <input onFocus={focus} onBlur={blur} tabindex="4" maxlength="64" className="field__input" id="update_order_multiple" min="0" step="1" type="number" value={orderMultiple} onChange={(e) => validateInteger(e, setOrderMultiple)} />
                    <div className="field__placeholder">Order Multiple</div>
                  </div>
                }

                { settings?.settings?.pack_quantities &&
                  <div className="field field--medium field--filled">
                    <span className="fieldset__svg-icon"></span>
                    <label className="field__label">Pack Quantity</label>
                    <input onFocus={focus} onBlur={blur} tabindex="4" maxlength="64" className="field__input" id="update_pack_quantity" min="0" step="1" type="number" value={packQuantity} onChange={(e) => validateInteger(e, setPackQuantity)} />
                    <div className="field__placeholder">Pack Quantity</div>
                  </div>
                }

              </div>


            </div>
            <div className="main-popup__buttons">
              <button type="button" className="btn btn-default btn-medium" tabindex="1000" onClick={() => clearAndClose()}>
                Cancel
              </button>
              <button type="button" className="btn btn-primary btn-medium" tabindex="1000" onClick={() => update()}>
                Update Assignment
              </button>
            </div>
            <div className="main-popup__footer-text" aria-hidden="true" style={{display: 'none'}}></div>
          </div>
        </div>
      </div>
    </div>

  )
}

const mapStateToProps = state => ({
  accountUnits: state.accounts.account.store_details.formatsAndUnits,
  settings: state.settings
});

const mapDispatchToProps = (dispatch) => ({
  updateAssignment: (payload, supplierId, assignment, assignmentValues) => dispatch(assignmentUpdate(payload, supplierId, assignment, assignmentValues)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditAssignmentModal);
